import React from 'react';
import {
    Select as MaterialSelect,
    SelectProps as MaterialSelectProps,
} from '@material-ui/core';
import { FormWrapper, StyledMenuItem } from './index.styles';

export interface SelectOptionProps {
    key: string;
    value: string;
}

export interface SelectProps extends MaterialSelectProps {
    label?: string;
    labelPosition?: string;
    options: SelectOptionProps[];
}

const Select: React.FC<SelectProps> = ({
    label,
    labelPosition = 'column',
    options,
    variant = 'outlined',
    ...rest
}): JSX.Element => {
    return (
        <FormWrapper labelPosition={labelPosition}>
            {label && <label>{label}</label>}
            <MaterialSelect displayEmpty variant={variant} {...rest}>
                {options.map((item) => (
                    <StyledMenuItem key={item.key} value={item.key}>
                        {item.value}
                    </StyledMenuItem>
                ))}
            </MaterialSelect>
        </FormWrapper>
    );
};

export default Select;
